import { SalesStrategyAndPrioritizationForm } from "@/components/campaign/setup/planning/SalesStrategyAndPrioritizationForm";
import { Configuration } from "@/types/campaign";
import { useStepperSubmitHandlerState } from "@/utils/stepper";
import { createFileRoute } from "@tanstack/react-router";
import { SetStateAction, useCallback } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/planning/sales-strategy-and-prioritization",
)({
  component: RouteComponent,
  loader: ({ context }) => {
    const title = context.stepper.stepperState.flatStepsByTo.get(
      Route.fullPath,
    )?.name;
    return {
      crumb: title,
      meta: { title },
    };
  },
});

function RouteComponent() {
  const context = Route.useRouteContext();
  const stepper = context.useStepper();

  const setConfigurations = useCallback(
    (action: SetStateAction<Configuration[]>) => {
      stepper.setContext((prev) => ({
        ...prev,
        configurations:
          typeof action === "function" ? action(prev.configurations) : action,
      }));

      stepper.goNext();
    },
    [stepper],
  );

  const [submitHandler, setSubmitHandler] = useStepperSubmitHandlerState();

  context.stepper.useStepperSubmit(submitHandler);

  return (
    <SalesStrategyAndPrioritizationForm
      configurations={stepper.context.configurations}
      updateConfigurations={setConfigurations}
      setSubmitHandler={setSubmitHandler}
    />
  );
}
